/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react'
import QRCode from 'qrcode.react'
import { useViewApp } from 'components/Editor/ViewApp'
import Modal from '../../Shared/Modal'

import './PromptTutorialModal.scss'

interface ShowQRCodeModalProps {
  appId: string
  onClose: () => void
}

export const ShowQRCodeModal: React.FC<ShowQRCodeModalProps> = ({
  appId,
  onClose,
}) => {
  const { publishUrl } = useViewApp(appId)

  const getUser = () => {
    const u = sessionStorage.getItem(`initial-application-user-${appId}`)

    if (u === null) return null

    return JSON.parse(u) as { email: string; password: string }
  }

  const user = getUser()

  return (
    <Modal onClose={onClose} size="md" grayOut scrolling>
      <div>
        <Modal.Header>
          <h2 className="prompt-tutorial-title">Preview QR Code</h2>
        </Modal.Header>
        <Modal.Content>
          <div className="prompt-tutorial-modal-content-center">
            {publishUrl !== undefined && (
              <div className="qr-code">
                <QRCode value={publishUrl} size={170} />
              </div>
            )}
            {publishUrl !== undefined && (
              <a
                target="_blank"
                rel="noreferrer"
                href={publishUrl}
                className="view-in-browser"
              >
                Open in Browser
              </a>
            )}
            {user !== null && (
              <div className="user-credentials">
                <div className="user-credentials-title">
                  Log in into the application using the following credentials:
                </div>
                <div className="user-credentials-row">
                  <b>Email:</b>
                  <span className="credential">{user.email}</span>
                </div>
                <div className="user-credentials-row">
                  <b>Password:</b>
                  <span className="credential">{user.password}</span>
                </div>
              </div>
            )}
          </div>
        </Modal.Content>
      </div>
    </Modal>
  )
}
